import './index.scss';
import './global.scss'; 
import './navigation.scss'; 
import './components.scss'; 
import './pages/all.ts';
import './resources.scss'; 
import './gallery.scss'; 

const BSN = require("bootstrap.native/dist/bootstrap-native.esm.min.js");
(window as any).BSN = BSN;
 
export default (async () => {
  console.log("Loaded 💖")

})();
